// Validating the employee data.

// Validating the units data for the draft del, requires the list of units, rather than individual unit data.
export const validateDraftDelUnits = (unitsDataArray) => {
  const errors = [];

  // Going through each unit in the unitsDataArray
  unitsDataArray.forEach((unit) => {
    // Creating a unit error object
    const unitError = {
      unitRowId: unit.rowId,
      errors: { unitId: "", unitType: "", billableUnits: "" },
    };

    // Checking for the unit id
    if (!unit.unitId || unit.unitId.trim() === "") {
      unitError.errors.unitId = "Unit is required";
    }
    // validating to make sure the billable units is a number or float
    if (unit.billableUnits) {
      const numericValue = parseFloat(unit.billableUnits);
      if (isNaN(numericValue)) {
        unitError.errors.billableUnits = "Quantity must be a number";
      }
    }

    // If the unitError object has any errors, then we need to add it to the errors array
    if (
      unitError.errors.unitId.length > 0 ||
      unitError.errors.unitType.length > 0 ||
      unitError.errors.billableUnits.length > 0
    ) {
      errors.push(unitError);
    }
  });
  return errors;
};

// Validating the units data for the submitted del, requires the list of units, rather than individual unit data.
export const validateSubmittedDelUnits = (unitsDataArray) => {
  const errors = [];

  // Going through each unit in the unitsDataArray
  unitsDataArray.forEach((unit) => {
    // Creating a unit error object
    const unitError = {
      unitRowId: unit.rowId,
      errors: { unitId: "", unitType: "", billableUnits: "" },
    };

    // Checking for the unit id
    if (!unit.unitId || unit.unitId.trim() === "") {
      unitError.errors.unitId = "Unit is required";
    }
    // validating to make sure the billable units is a number or float
    if (unit.billableUnits) {
      const numericValue = parseFloat(unit.billableUnits);
      if (isNaN(numericValue)) {
        unitError.errors.billableUnits = "Quantity must be a number";
      }
    }
    // Billable units is not none
    if (!unit.billableUnits || unit.billableUnits === null) {
      unitError.errors.billableUnits = "Quantity is required";
    }

    // If the unitError object has any errors, then we need to add it to the errors array
    if (
      unitError.errors.unitId.length > 0 ||
      unitError.errors.unitType.length > 0 ||
      unitError.errors.billableUnits.length > 0
    ) {
      errors.push(unitError);
    }
  });
  return errors;
};

// Setting up validation for the misc equipment
export const validateDraftMiscEquipment = (miscEquipmentArray) => {
  const errors = [];

  // Going through each misc equipment in the miscEquipmentArray
  miscEquipmentArray.forEach((miscEquipment) => {
    // Creating a misc equipment error object
    const miscEquipmentError = {
      miscEquipmentRowId: miscEquipment.rowId,
      errors: { unitName: "", quantity: "", quantityType: "", vendor: "" },
    };

    // Checking for the unit name
    if (!miscEquipment.unitName || miscEquipment.unitName.trim() === "") {
      miscEquipmentError.errors.unitName = "Unit name is required";
    }

    // Checking to make sure the quantity is a number or float
    if (miscEquipment.quantity) {
      const numericValue = parseFloat(miscEquipment.quantity);
      if (isNaN(numericValue)) {
        miscEquipmentError.errors.quantity = "Quantity must be a number";
      }
    }

    // Checking to make sure the quantity type is a valid quantity type
    if (miscEquipment.quantityType) {
      console.log("Quantity type:", miscEquipment.quantityType);
      if (
        miscEquipment.quantityType.toLowerCase() !== "each" &&
        miscEquipment.quantityType.toLowerCase() !== "hours" &&
        miscEquipment.quantityType.toLowerCase() !== "days"
      ) {
        miscEquipmentError.errors.quantityType = "Invalid quantity type";
      }
    }

    // Seeing if we need to add the misc equipment to the errors array
    if (
      miscEquipmentError.errors.unitName.length > 0 ||
      miscEquipmentError.errors.quantity.length > 0 ||
      miscEquipmentError.errors.quantityType.length > 0 ||
      miscEquipmentError.errors.vendor.length > 0
    ) {
      errors.push(miscEquipmentError);
    }
  });

  return errors;
};

// Setting up validation for the misc equipment
export const validateSubmittedMiscEquipment = (miscEquipmentArray) => {
  const errors = [];

  // Going through each misc equipment in the miscEquipmentArray
  miscEquipmentArray.forEach((miscEquipment) => {
    // Creating a misc equipment error object
    const miscEquipmentError = {
      miscEquipmentRowId: miscEquipment.rowId,
      errors: { unitName: "", quantity: "", quantityType: "", vendor: "" },
    };

    // Checking for the unit name
    if (!miscEquipment.unitName || miscEquipment.unitName.trim() === "") {
      miscEquipmentError.errors.unitName = "Unit name is required";
    }

    // Checking to make sure the quantity is not null
    if (!miscEquipment.quantity) {
      miscEquipmentError.errors.quantity = "Quantity is required";
    }

    // Checking to make sure the quantity is a number or float

    if (miscEquipment.quantity) {
      const numericValue = parseFloat(miscEquipment.quantity);
      if (isNaN(numericValue)) {
        miscEquipmentError.errors.quantity = "Quantity must be a number";
      }
    }

    // Checking to make sure the quantity type is a valid quantity type
    if (!miscEquipment.quantityType) {
      miscEquipmentError.errors.quantityType = "Quantity type is required";
    } else {
      if (
        miscEquipment.quantityType.toLowerCase() !== "each" &&
        miscEquipment.quantityType.toLowerCase() !== "hours" &&
        miscEquipment.quantityType.toLowerCase() !== "days"
      ) {
        miscEquipmentError.errors.quantityType = "Invalid quantity type";
      }
    }

    // Seeing if we need to add the misc equipment to the errors array

    if (
      miscEquipmentError.errors.unitName.length > 0 ||
      miscEquipmentError.errors.quantity.length > 0 ||
      miscEquipmentError.errors.quantityType.length > 0
    ) {
      errors.push(miscEquipmentError);
    }
  });

  return errors;
};

// Validating the rental equipment
export const validateDraftRentalEquipment = (rentalEquipmentArray) => {
  const errors = [];
  // Going through each rental equipment in the rentalEquipmentArray
  rentalEquipmentArray.forEach((rentalEquipment) => {
    // Creating a rental equipment error object
    const rentalEquipmentError = {
      rentalEquipmentRowId: rentalEquipment.rowId,

      errors: { unitName: "", quantity: "", quantityType: "", vendor: "" },
    };

    // Checking for the unit name
    if (!rentalEquipment.itemName || rentalEquipment.itemName.trim() === "") {
      rentalEquipmentError.errors.unitName = "Unit name is required";
    }

    // Checking to make sure the quantity is a number or float
    if (rentalEquipment.quantity) {
      const numericValue = parseFloat(rentalEquipment.quantity);
      if (isNaN(numericValue)) {
        rentalEquipmentError.errors.quantity = "Quantity must be a number";
      }
    }

    // Checking to make sure the quantity type is a valid quantity type
    if (rentalEquipment.quantityType) {
      if (
        rentalEquipment.quantityType.toLowerCase() !== "hours" &&
        rentalEquipment.quantityType.toLowerCase() !== "day"
      ) {
        rentalEquipmentError.errors.quantityType = "Invalid quantity type";
      }
    }

    // Seeing if we need to add the misc equipment to the errors array
    if (
      rentalEquipmentError.errors.unitName.length > 0 ||
      rentalEquipmentError.errors.quantity.length > 0 ||
      rentalEquipmentError.errors.quantityType.length > 0 ||
      rentalEquipmentError.errors.vendor.length > 0
    ) {
      errors.push(rentalEquipmentError);
    }
  });

  return errors;
};

// Validating the rental equipment
export const validateSubmittedRentalEquipment = (rentalEquipmentArray) => {
  const errors = [];
  // Going through each rental equipment in the rentalEquipmentArray
  rentalEquipmentArray.forEach((rentalEquipment) => {
    // Creating a rental equipment error object
    const rentalEquipmentError = {
      rentalEquipmentRowId: rentalEquipment.rowId,

      errors: { unitName: "", quantity: "", quantityType: "", vendor: "" },
    };

    // Checking for the unit name
    if (!rentalEquipment.itemName || rentalEquipment.itemName.trim() === "") {
      rentalEquipmentError.errors.unitName = "Unit name is required";
    }

    // Checking to make sure the quantity is a number or float
    if (rentalEquipment.quantity) {
      const numericValue = parseFloat(rentalEquipment.quantity);
      if (isNaN(numericValue)) {
        rentalEquipmentError.errors.quantity = "Quantity must be a number";
      }
    }

    // Checking to make sure the quantity is not null
    if (!rentalEquipment.quantity) {
      rentalEquipmentError.errors.quantity = "Quantity is required";
    }

    // Checking to make sure the quantity type is a valid quantity type
    if (!rentalEquipment.quantityType) {
      rentalEquipmentError.errors.quantityType = "Quantity type is required";
    } else {
      if (
        rentalEquipment.quantityType.toLowerCase() !== "hours" &&
        rentalEquipment.quantityType.toLowerCase() !== "day"
      ) {
        rentalEquipmentError.errors.quantityType = "Invalid quantity type";
      }
    }

    // Checking to make sure vendor is not null
    if (!rentalEquipment.vendor) {
      rentalEquipmentError.errors.vendor = "Vendor is required";
    }

    // Seeing if we need to add the misc equipment to the errors array

    if (
      rentalEquipmentError.errors.unitName.length > 0 ||
      rentalEquipmentError.errors.quantity.length > 0 ||
      rentalEquipmentError.errors.quantityType.length > 0 ||
      rentalEquipmentError.errors.vendor.length > 0
    ) {
      errors.push(rentalEquipmentError);
    }
  });

  return errors;
};

// Validating the project-specific units for draft
export const validateDraftProjectSpecificUnits = (projectUnitsArray) => {
  const errors = [];

  projectUnitsArray.forEach((unit) => {
    const unitError = {
      projectUnitRowId: unit.rowId,
      errors: { unitNumber: "", quantity: "" },
    };

    // Checking to make sure the quantity is a number or float if present
    if (unit.quantity) {
      const numericValue = parseFloat(unit.quantity);
      if (isNaN(numericValue)) {
        unitError.errors.quantity = "Quantity must be a number";
      }
    }

    if (
      unitError.errors.unitNumber.length > 0 ||
      unitError.errors.quantity.length > 0
    ) {
      errors.push(unitError);
    }
  });

  return errors;
};

// Validating the project-specific units for submitted del
export const validateSubmittedProjectSpecificUnits = (projectUnitsArray) => {
  const errors = [];

  projectUnitsArray.forEach((unit) => {
    const unitError = {
      projectUnitRowId: unit.rowId,
      errors: { unitNumber: "", quantity: "" },
    };

    // Checking for the unit number
    if (!unit.unitNumber || unit.unitNumber.trim() === "") {
      unitError.errors.unitNumber = "Unit is required";
    }

    // Checking to make sure the quantity is not null
    if (!unit.quantity && unit.quantity !== 0) {
      unitError.errors.quantity = "Quantity is required";
    }

    // Checking to make sure the quantity is a number or float
    if (unit.quantity) {
      const numericValue = parseFloat(unit.quantity);
      if (isNaN(numericValue)) {
        unitError.errors.quantity = "Quantity must be a number";
      }
    }

    if (
      unitError.errors.unitNumber.length > 0 ||
      unitError.errors.quantity.length > 0
    ) {
      errors.push(unitError);
    }
  });

  return errors;
};
